// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1r_VD","col":"styles_col__2Nh6w"};